<template>
  <div class="announcement-page">
<h2>【重要】サービス終了のお知らせ</h2>
<dl>
平素ご愛顧いただき、誠にありがとうございます。<br>
占いTVは、2023年5月31日をもちましてサービスを終了いたします。<br>
<br>
記<br><br>
■提供終了サービス ：占いTV<br>
■サービス終了日 ：2023年5月31日（水）<br>
<br>
■今後のスケジュール<br>
2023年4月28日（金）継続更新の停止<br>
2023年5月31日（水）サービス終了<br>
<br>
<br>
■サービス解約について<br>
2023年4月28日（金）をもって自動解約となります。また、2023年5月31日（水）まではサービスのご利用が可能です。<br>
<br>
<br>
■ご購入商品について<br>
ご購入された商品については、サービス終了日（2023年5月31日）まで閲覧可能です。<br>
<br>
<br>
■ポイント残高について<br>
占いTV内のポイントは、2023年5月31日（水）をもって無効となります。<br>
<br>
＊ポイント利用規約<br>
<a href="https://www.uranai.tv/terms">https://www.uranai.tv/terms</a> <br>
<br>
<br>
■個人情報のお取り扱いについて<br>
サービス終了に伴い、責任をもって全て削除いたしますが、お問い合わせ等の対応のため一定期間保有する場合があります。<br>
<br>
<br>
■お問い合わせ先<br>
上記内容に関するお問い合わせは、下記にて承ります。<br>
<br>
株式会社ザッパラス<br>
<a href="https://www.zappallas.com/contact/">https://www.zappallas.com/contact/</a><br>
<br>
<br>
<br>
これまでのご愛顧に厚くお礼申し上げますとともに、大変ご迷惑をおかけすることを深くお詫び申し上げます。<br>
<br>
サービス終了まで、残り僅かとなりますが「占いTV」を最後まで何卒よろしくお願い申し上げます。<br>
<br>
占いTV運営事務局一同<br>
</dd>
</dl>
  </div>
</template>

<script>
export default {
  name: "AnnouncementPage",
}
</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.announcement-page {
  color: $col_base_black;
  font-size: 13px;
  line-height: 1.7;
  padding: 1px 4px 30px;
  h2 {
    font-weight: bold;
    font-size: 21px;
    text-align: center;
    margin: 45px 0 30px;
  }
  dl {
    padding: 0;
    margin: 0 0 1em;
    > dt {
      font-weight: bold;
      font-size: 13px;
      margin: 1.6em 0 1em;
      &:first-child {
        margin-top: 0;
      }
    }
    > dd {
      margin: 0 0 1em;
    }
  }
  ul {
    padding: 0;
    margin: 1em 0;
    > li {
      list-style: disc inside;
      margin: 0 0 0.5em 1.7em;
      text-indent: -1.3em;
    }
  }
  a {
    color: inherit;
  }
  b {
    font-weight: bold;
  }
  small {
    color: $col_temp_gray6;
    font-size: inherit;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Help/Announcement.vue